
export default function ThreeTierLegend() {
  const tiers = [
    {
      name: 'Everyday',
      dotColor: '#F2C612',
      description: 'Great value for DIY and light-duty projects',
    },
    {
      name: 'Contractor Grade',
      dotColor: '#2D7AC2',
      description: 'Professional performance for demanding jobs',
    },
    {
      name: 'Elite Pro',
      dotColor: '#D42B2B',
      description: 'Premium quality for the most critical applications',
    },
  ];

  return (
    <section className="bg-gray-50 py-12 md:py-16 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-['Montserrat'] font-bold text-2xl md:text-3xl text-center mb-8 md:mb-12 text-[#1A1A1A]">
          Understanding Our Three-Tier System
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className="bg-white p-6 md:p-8 rounded-lg shadow-sm border border-gray-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-4 h-4 rounded-full flex-shrink-0" style={{ backgroundColor: tier.dotColor }}></div>
                <h3 className="font-['Montserrat'] font-bold text-lg md:text-xl text-[#1A1A1A]">
                  {tier.name}
                </h3>
              </div>
              <p className="text-sm md:text-base text-gray-600">{tier.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
